import { render, staticRenderFns } from "./AttributeWidgetTemplate.vue?vue&type=template&id=be7d24f4&scoped=true"
import script from "./AttributeWidgetTemplate.vue?vue&type=script&lang=js"
export * from "./AttributeWidgetTemplate.vue?vue&type=script&lang=js"
import style0 from "./AttributeWidgetTemplate.vue?vue&type=style&index=0&id=be7d24f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d24f4",
  null
  
)

export default component.exports